/* ============================================
   DEXAP — Product Page JS
   assets/dexap-product.js
   ============================================ */

(function () {
  'use strict';

  /* ---- QUANTITY ---- */
  var dexapQtyVal = 1;

  window.dexapQty = function (delta) {
    dexapQtyVal = Math.max(1, Math.min(10, dexapQtyVal + delta));
    var qtyEl = document.getElementById('dexap-qty');
    if (qtyEl) qtyEl.textContent = dexapQtyVal;
  };

  /* ---- GALLERY THUMBNAILS ---- */
  window.dexapSetImage = function (el) {
    var img = document.getElementById('dexap-main-img');
    if (!img) return;
    img.style.opacity = '0';
    setTimeout(function () {
      img.src = el.getAttribute('data-src');
      img.style.opacity = '1';
    }, 200);
    document.querySelectorAll('.dexap-thumb').forEach(function (t) {
      t.classList.remove('active');
    });
    el.classList.add('active');
  };

  /* ---- VARIANT SELECTION ---- */
  var selectedOptions = {};

  window.dexapSelectOption = function (btn) {
    var idx = btn.getAttribute('data-option-index');
    var val = btn.getAttribute('data-option-value');
    selectedOptions[idx] = val;

    btn.closest('.dexap-var-btns')
      .querySelectorAll('.dexap-var-btn')
      .forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');

    var sel = document.getElementById('dexap-variant-select');
    if (!sel) return;
    var opts = Array.from(sel.options);
    
    var matched = opts.find(function (o) {
      var variant = dexapProduct.variants.find(function (v) { return String(v.id) === String(o.value); });
      if (!variant) return false;
      return Object.keys(selectedOptions).every(function (i) {
        return variant['option' + (parseInt(i) + 1)] === selectedOptions[i];
      });
    });

    if (matched) {
      sel.value = matched.value;
      dexapUpdatePrice(matched);

      var variantData = dexapProduct.variants.find(function (v) { return String(v.id) === String(matched.value); });
      
      if (variantData && variantData.featured_image) {
        var mainImg = document.getElementById('dexap-main-img');
        if (mainImg) {
          mainImg.style.opacity = '0';
          setTimeout(function () {
            mainImg.src = variantData.featured_image.src;
            mainImg.style.opacity = '1';
          }, 200);

          try {
            mainImg.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          } catch(e) {
            mainImg.scrollIntoView(); 
          }
        }
      }
    }
  };

  function dexapUpdatePrice(option) {
    var price = parseInt(option.getAttribute('data-price'), 10);
    var compare = parseInt(option.getAttribute('data-compare'), 10);
    var priceEl = document.getElementById('dexap-price');
    if (priceEl) priceEl.textContent = dexapFormatMoney(price);
    var compareEl = document.getElementById('dexap-compare-price');
    if (compareEl && compare > price) compareEl.textContent = dexapFormatMoney(compare);
  }

  function dexapFormatMoney(cents) {
    return (cents / 100).toLocaleString('en-GB', { style: 'currency', currency: 'GBP' });
  }

  /* ---- ADD TO CART (Bundle Uyumlu) ---- */
  window.dexapAddToCart = function () {
    var sel = document.getElementById('dexap-variant-select');
    var variantId = sel ? sel.value : dexapProduct.currentVariantId;
    var btn = document.getElementById('dexap-cart-btn');
    if (!btn) return;

    var finalQty = dexapQtyVal;
    var bundlerQtyInput = document.querySelector('#dexap-bundle-form input[name="quantity"]') || 
                          document.querySelector('#bundler-widget-target input[name="quantity"]') ||
                          document.querySelector('.bundler-target-element input[name="quantity"]');
    
    if (bundlerQtyInput && parseInt(bundlerQtyInput.value) > 1) {
      finalQty = parseInt(bundlerQtyInput.value);
    }
    
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: finalQty })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        btn.textContent = '✓  ADDED TO CART!';
        btn.classList.add('added');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function () {
          btn.textContent = '🛒  ADD TO CART';
          btn.classList.remove('added');
          btn.disabled = false;
        }, 2400);
      })
      .catch(function (err) {
        btn.textContent = '⚠  TRY AGAIN';
        btn.disabled = false;
      });
  };

  /* ---- TABS (Geri Getirilen Kısım) ---- */
  window.dexapTab = function (id, el) {
    // Tüm panelleri gizle
    document.querySelectorAll('.dexap-panel').forEach(function (p) {
      p.classList.remove('visible');
    });
    // Tüm sekmelerden aktifliği kaldır
    document.querySelectorAll('.dexap-tab').forEach(function (t) {
      t.classList.remove('active');
    });
    // Seçilen paneli göster ve sekmeyi aktif yap
    var panel = document.getElementById('dexap-panel-' + id);
    if (panel) panel.classList.add('visible');
    el.classList.add('active');

    // Eğer yorumlar sekmesi açılıyorsa Judge.me widget'ını tazele
    if (id === 'reviews' && window.jdgm) {
      jdgm.customWidgets.initAll();
    }
  };

  /* ---- COUNTDOWN TIMER ---- */
  (function () {
    var KEY = 'dexap_timer_end';
    var DURATION = 3 * 60 * 60 * 1000;
    var end = parseInt(sessionStorage.getItem(KEY), 10);
    if (!end || end < Date.now()) {
      end = Date.now() + DURATION;
      sessionStorage.setItem(KEY, end);
    }
    function tick() {
      var diff = Math.max(0, end - Date.now());
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var hEl = document.getElementById('dexap-h');
      var mEl = document.getElementById('dexap-m');
      var sEl = document.getElementById('dexap-s');
      if (hEl) hEl.textContent = String(h).padStart(2, '0');
      if (mEl) mEl.textContent = String(m).padStart(2, '0');
      if (sEl) sEl.textContent = String(s).padStart(2, '0');
      if (diff > 0) setTimeout(tick, 1000);
    }
    tick();
  })();

  /* ---- LIVE VIEWER COUNT ---- */
  (function () {
    var base = 18;
    var countEl = document.getElementById('dexap-viewer-count');
    var txtEl = document.getElementById('dexap-viewer-txt');
    function update() {
      var v = base + Math.floor(Math.random() * 12);
      if (countEl) countEl.textContent = v;
      if (txtEl) txtEl.textContent = v + ' people are viewing this right now';
      var next = 6000 + Math.random() * 8000;
      setTimeout(update, next);
    }
    update();
  })();

  /* ---- JUDGE.ME POLLER ---- */
  (function () {
    var attempts = 0;
    var poller = setInterval(function () {
      attempts++;
      var badge = document.querySelector('.jdgm-preview-badge');
      if (badge) {
        var countNode = badge.querySelector('.jdgm-numreviews');
        if (countNode) {
          var n = countNode.textContent.replace(/\D/g, '');
          var label = document.getElementById('dexap-review-count');
          if (label && n) label.textContent = '(' + n + ')';
          clearInterval(poller);
          return;
        }
      }
      if (attempts > 30) clearInterval(poller);
    }, 500);
  })();

})();